import { Suspense } from 'react'
import { QueryErrorResetBoundary } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import Loading3QuartersOutlined from '@ant-design/icons/Loading3QuartersOutlined'
import { ErrorBoundary } from './ErrorBoundary'
import ErrorFallback from './ErrorFallback'

interface Props {
  children?: React.ReactNode
}

export default function QueryErrorBoundary({ children }: Props) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary onReset={reset} fallbackRender={ErrorFallback}>
          <ReactQueryDevtools initialIsOpen={false} />
          <Suspense fallback={<Loading3QuartersOutlined spin />}>{children}</Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
